import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FlexLayoutModule, FlexModule } from "@ngbracket/ngx-layout";
import { AccountsPayableModule } from "@tylertech/accounts-payable-module";
import { AggregatesModule } from "@tylertech/aggregates-module";
import { AttachmentsModule } from "@tylertech/attachments-module";
import { ChartJsContainerComponent } from "@tylertech/chart-js";
import { ChartingModule } from "@tylertech/charting-module";
import { CommandsModule } from "@tylertech/commands-module";
import { CommonComponentsModule } from "@tylertech/common-components-module";
import { CoreModule } from "@tylertech/core-module";
import { CustomViewModule } from "@tylertech/custom-view";
import { DataLoadModule } from "@tylertech/data-load-module";
import { GeneralLedgerModule } from "@tylertech/general-ledger-module";
import { IntentsModule } from "@tylertech/intents-module";
import { LgdCheckboxModule, LgdCurrencyModule, LgdDatePickerModule, LgdTextAreaModule, LgdTextModule, LgdTypeAheadModule } from "@tylertech/lgd-reactive-forms";
import { NotesModule } from "@tylertech/notes-module";
import { SearchModule } from "@tylertech/search-module";
import { PurchaseOrderApprovalActionHandler, RequisitionApprovalActionHandler } from "./aggregateActionHandlers";
import
{
    InvoiceDialogComponent,
    InvoiceHistoryComponent,
    OpenPurchaseOrdersByDepartmentChartComponent,
    PoApprovalDialogComponent,
    PoNoticeEmailsComponent,
    PoStatusChartComponent,
    RequisitionApprovalChartComponent,
    RequisitionSelectionDialogComponent,
    RequisitionSelectionReviewComponent,
    RequisitionStatusChartComponent,
} from "./components";
import
{
    BidQuoteComponent,
    BidQuotesComponent,
    BidQuotesDialogComponent
} from "./dialogs";
import
{
    DepartmentLookupService,
    EPurchasingService,
    LegacyRequisitionService,
    ModuleControlService,
    PurchaseOrderLookupService,
    PurchaseOrderService,
    PurchasingChartService,
    PurchasingDialogsService,
    ReceiveGoodsService,
    ReqAndPoLookupService,
    RequestedByLookupService,
    RequisitionApprovalService,
    RequisitionLookupService,
    RequisitionSearchService,
    RequisitionService,
} from "./services";

const angularModules = [
    CommonModule,
    FlexModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
];

const angularMaterialModules = [
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatListModule,
    MatStepperModule,
    MatTableModule,
    MatToolbarModule,
];

const lgdModules = [
    LgdCheckboxModule,
    LgdCurrencyModule,
    LgdDatePickerModule,
    LgdTextAreaModule,
    LgdTextModule,
    LgdTypeAheadModule,
    CommandsModule,
    CommonComponentsModule,
    CoreModule,
    CustomViewModule
        .withComponents(
            /* eslint-disable @typescript-eslint/naming-convention */
            {
                "purchasing-open-purchase-orders-by-department-chart": OpenPurchaseOrdersByDepartmentChartComponent,
                "purchasing-po-status-chart": PoStatusChartComponent,
                "purchasing-requisition-approval-chart": RequisitionApprovalChartComponent,
                "purchasing-requisition-status-chart": RequisitionStatusChartComponent
            }
            /* eslint-enable @typescript-eslint/naming-convention */
        ),
    AggregatesModule
        .withActionHandlers(
            PurchaseOrderApprovalActionHandler,
            RequisitionApprovalActionHandler,
        ),
    ChartJsContainerComponent,
    ChartingModule,
    DataLoadModule,
    NotesModule,
    SearchModule,
    IntentsModule,
    GeneralLedgerModule,
    AccountsPayableModule,
    AttachmentsModule,
];

const components = [
    BidQuoteComponent,
    BidQuotesComponent,
    BidQuotesDialogComponent,
    InvoiceDialogComponent,
    InvoiceHistoryComponent,
    OpenPurchaseOrdersByDepartmentChartComponent,
    PoApprovalDialogComponent,
    PoNoticeEmailsComponent,
    PoStatusChartComponent,
    RequisitionApprovalChartComponent,
    RequisitionSelectionDialogComponent,
    RequisitionSelectionReviewComponent,
    RequisitionStatusChartComponent,
];
@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules
    ],
    declarations: components,
    exports: components,
    providers: [
        DepartmentLookupService,
        EPurchasingService,
        LegacyRequisitionService,
        ModuleControlService,
        PurchaseOrderLookupService,
        PurchaseOrderService,
        PurchasingChartService,
        PurchasingDialogsService,
        ReceiveGoodsService,
        ReqAndPoLookupService,
        RequestedByLookupService,
        RequisitionApprovalService,
        RequisitionLookupService,
        RequisitionSearchService,
        RequisitionService,
        PurchaseOrderApprovalActionHandler,
        RequisitionApprovalActionHandler,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PurchasingModule { }
